import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Polygon, Marker } from 'react-leaflet';
import L from 'leaflet';
import { renderToString } from 'react-dom/server';

import {
    relocateZoneDraftCoords,
    zoneDraftMapControlSelector, zoneDraftCoordsSelector, zoneDraftColorSelector
} from '../../../features/places/placesSlice';

const OsmZoneCreate = () => {

    const dispatch = useDispatch();
    const zoneDraftMapControl = useSelector(zoneDraftMapControlSelector);
    const zoneDraftCoords = useSelector(zoneDraftCoordsSelector);
    const zoneDraftColor = useSelector(zoneDraftColorSelector);


    const relocateVertex = (e, i) => {
        dispatch(relocateZoneDraftCoords({
            index: i,
            coords: {
                lat: e.target.getLatLng().lat,
                lng: e.target.getLatLng().lng
            }
        }))
    }


    if (!zoneDraftMapControl) {
        return null;
    } else {
        return (
            <div>
                <Polygon
                    positions={zoneDraftCoords}
                    pathOptions={{
                        color: zoneDraftColor,
                        fillColor: zoneDraftColor,
                    }}
                />
                {
                    zoneDraftCoords.map((v, i) =>
                        <Marker
                            position={v}
                            draggable={true}
                            autoPan={true}
                            key={i}
                            eventHandlers={{
                                dragend: (e) => relocateVertex(e, i),
                            }}
                            icon={L.divIcon({
                                html: renderToString(
                                    <div style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '100%',
                                        textAlign: 'center',
                                        display: 'flex',
                                        backgroundColor: 'crimson',
                                        color: 'white',
                                        width: '25px',
                                        height: '25px',
                                    }}>
                                        <b>{`${i + 1}`}</b>
                                    </div>
                                ),
                                iconAnchor: [10, 10],
                                className: 'dummy'
                            })}
                        />
                    )
                }
            </div>
        );
    }
}

export default OsmZoneCreate;